export const MAX_FREE_REPRS = 50

export const DEFAULT_DAYS_WARNING = 30
export const DEFAULT_DAYS_WARNING_MIN = 0
export const DEFAULT_DAYS_WARNING_MAX = 365

export const DEFAULT_WARNING_RATIO = 0.5

export const MAX_PRACTICED_DATES = 100

export const MY_EMAIL = 'kevinsmithwebdev@gmail.com'

export const COPYRIGHT_YEAR = '2022'
